export default '$$material';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/styles/identifier.js
// module id = 166
// module chunks = 31